export const APP_IFRAME = {
  "Iframe.Space.Around": {
    defaultValue: "default"
  },
  "Iframe.Space.Around.Top": {
    defaultValue: "2px"
  },
  "Iframe.Space.Around.Right": {
    defaultValue: "2px"
  },
  "Iframe.Space.Around.Bottom": {
    defaultValue: "2px"
  },
  "Iframe.Space.Around.Left": {
    defaultValue: "2px"
  },

  "Iframe.Height.Type": {
    defaultValue: "fixed"
  },

  "Iframe.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Iframe.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Iframe.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Iframe.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Iframe.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Iframe.Padding.Left": {
    defaultValue: "0px"
  },
  "Iframe.Padding.Right": {
    defaultValue: "0px"
  },
  "Iframe.Padding.Top": {
    defaultValue: "0px"
  },
  "Iframe.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Iframe.Border.Color": {
    ref: "Color.Transparent"
  },
  "Iframe.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Iframe.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Iframe.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Iframe.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Iframe.Shadow": {
    defaultValue: "none"
  },
  "Iframe.Box.Sizing": {
    defaultValue: "border-box"
  },
  "Iframe.Width": {
    defaultValue: "100%"
  },
  "Iframe.Height": {
    defaultValue: "500px"
  },
  "Iframe.Max.Height": {
    defaultValue: "unset"
  },
  "Iframe.Max.Width": {
    defaultValue: "unset"
  },
  "Iframe.Min.Width": {
    defaultValue: "unset"
  },
  "Iframe.Min.Height": {
    defaultValue: "0px"
  },
  "Iframe.Overflow": {
    defaultValue: "auto"
  },
  "Iframe.Margin.Top": {
    defaultValue: "0px"
  },
  "Iframe.Margin.Right": {
    defaultValue: "0px"
  },
  "Iframe.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Iframe.Margin.Left": {
    defaultValue: "0px"
  },
  "Iframe.Border.Style": {
    defaultValue: "solid"
  },
  "Iframe.Shadow.Type": {
    defaultValue: "none"
  },
  "Iframe.Shadow.Color": {
    ref: "Color.Shadow"
  },
  "Iframe.Cursor": {
    defaultValue: "pointer"
  }
};
